module.exports = {
    methods: {
        $price(value, currency, addVat, vatRate) {

            value = value || 0.00;
            currency = currency || this.$currency;
            addVat = addVat !== undefined ? addVat : false;

            let locale = this.$localeIcu || 'da-DK';

            const moneyFormatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
            });

            if (addVat) {
                vatRate = vatRate || this.$vatRate;
                value = parseFloat(value) + (value * vatRate / 100);
            }

            return moneyFormatter.format(value);
        },
    },
}